import { render, staticRenderFns } from "./ProductListApp.vue?vue&type=template&id=c03e08c4&scoped=true"
import script from "./ProductListApp.vue?vue&type=script&lang=ts"
export * from "./ProductListApp.vue?vue&type=script&lang=ts"
import style0 from "./ProductListApp.vue?vue&type=style&index=0&id=c03e08c4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03e08c4",
  null
  
)

export default component.exports